import { BaseFiltroPagDTO } from "./base-dto";

export class DashboardFiltrosDTO extends BaseFiltroPagDTO {
  cdsAreas: string[];
  idsVisitantes: number[];
  dataIni: string;
  dataFim: string;
}